<app-ark-container
  [future]="dataObservable"
  [loadingTemplate]="loading"
  [successTemplate]="success"
  [failureTemplate]="failure"
  [errorTemplate]="error"
  (onSuccess)="onDataResolved($event[0])"
>
</app-ark-container>
<ng-template #loading>
  <div class="section">
    <ul>
      <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </div>
</ng-template>
<ng-template #failure>
  <div class="error-container">
    <div class="error-msg">
      <!-- <va-icon name="faInfoCircle" class="info-icon"></va-icon> -->
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #error>
  <div class="error-container">
    <div class="error-msg">
      <!-- <va-icon name="faInfoCircle" class="info-icon"></va-icon> -->
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #success>
  <div
    class="ant-grid-container"
    *ngIf="selectedTab === 'company' && dataSet && !hasError"
  >
    <app-ant-grid-custom
      (selectedRows)="getSelectedRows($event[0])"
      (sortChange)="onSortChange($event[0])"
      [(dataToUse)]="dataToUse"
      (paginationChange)="paginationChanged($event[0], $event[1])"
    >
    </app-ant-grid-custom>
  </div>
  <div *ngIf="selectedTab === 'watchlist' && dataSet && !hasError" class="alert-watchlist-grid">
    <!-- add watchlist grid here -->
    <nz-table
      #nestedTable
      [nzData]="processedData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      nzSize="middle"
      [nzScroll]="{ y: 'calc(100vh - 320px)', x: 'auto' }"
    >
      <thead>
        <tr>
          <th nzWidth="4%" nzShowExpand></th>
          <th
            nzWidth="4%"
            nzShowCheckbox
            [(nzChecked)]="isAllDisplayDataChecked"
            [nzIndeterminate]="isIndeterminate"
            (nzCheckedChange)="checkAll($event)"
          ></th>
          <th nzWidth="30%" [nzAlign]="'left'">Watchlist</th>
          <th nzWidth="25%" [nzAlign]="'left'">Alerts</th>
          <th nzWidth="20%" [nzAlign]="'left'">Notification Option</th>
          <th nzWidth="8%" [nzAlign]="'left'">Actions</th>
          <th nzWidth="8%" [nzAlign]="'left'">Enable</th>
        </tr>
      </thead>
      <tbody>
        <ng-template ngFor let-data [ngForOf]="processedData">
          <tr>
            <td 
              nzShowExpand 
              [(nzExpand)]="data.expand"
            ></td>
            <td
              nzShowCheckbox
              [(nzChecked)]="mapOfCheckedId[data.id]"
              (nzCheckedChange)="refreshStatus()"
              [nzDisabled]="data.selectionDisabled"
            ></td>
            <td>{{ data.watchlistName }}</td>
            <td>{{ data.alerts }}</td>
            <td>{{ data.notification }}</td>
            <td>
              <app-alert-grid-action-renderer
                [dataObj]="data.actions"
              ></app-alert-grid-action-renderer>
            </td>
            <td>
              <app-checkbox-renderer
                [dataObj]="data.enable"
              ></app-checkbox-renderer>
            </td>
          </tr>
          <tr [nzExpand]="data.expand">
            <td colspan="2" style="width: 5%;"></td>
            <td colspan="5">
              <nz-table
                #innerTable
                [nzData]="data.children"
                [nzFrontPagination]="false"
                [nzShowPagination]="false"
                [nzBordered]="true"
                nzSize="middle"
                [nzScroll]="{ y: '200px' }"
              >
                <thead>
                  <tr>
                    <th nzWidth="auto">Company Name</th>
                    <th nzWidth="20%">Ticker</th>
                    <th nzWidth="20%">Bloomberg Ticker</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of data.children">
                    <td>{{ row.name }}</td>
                    <td>{{ row.ticker }}</td>
                    <td>{{ row.b_ticker }}</td>
                  </tr>
                </tbody>
              </nz-table>
            </td>
          </tr>
        </ng-template>
      </tbody>
    </nz-table>
  </div>
</ng-template>
